import React from 'react';
import { fileUrl } from '../../salesApi';
import { useT } from '../../salesI18n';
import { fmtInches } from './InchesInput';

// Linhas de medida (coords 0..1) por cima de uma imagem. Linhas em SVG esticado (stroke fixo); pontos e rótulos em HTML (não distorcem).
export const MarksOverlay = ({ marks = [], measures = {}, showLabels = true, pending = null, compact = false }) => {
  const { t } = useT();
  const pct = (v) => `${(v * 100).toFixed(2)}%`;
  const label = (m) => { const v = measures[m.field]; return v ? `${fmtInches(v)}"` : (t.measureShort[m.field] || m.field); };
  return (
    <>
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 1000 1000" preserveAspectRatio="none" aria-hidden="true">
        {marks.map((m, i) => <line key={i} x1={m.x1 * 1000} y1={m.y1 * 1000} x2={m.x2 * 1000} y2={m.y2 * 1000} stroke="#FFE600" strokeWidth={compact ? 2 : 3} strokeLinecap="round" vectorEffect="non-scaling-stroke" />)}
      </svg>
      {!compact && marks.flatMap((m, i) => [[m.x1, m.y1], [m.x2, m.y2]].map(([x, y], j) => <span key={`${i}-${j}`} className="absolute h-3 w-3 -ml-1.5 -mt-1.5 rounded-full bg-teal-600 border-2 border-white shadow pointer-events-none" style={{ left: pct(x), top: pct(y) }} />))}
      {pending && <span className="absolute h-3.5 w-3.5 -ml-[7px] -mt-[7px] rounded-full bg-amber-400 border-2 border-white shadow animate-pulse pointer-events-none" style={{ left: pct(pending.x), top: pct(pending.y) }} data-testid="mark-pending-point" />}
      {showLabels && !compact && marks.map((m, i) => (
        <span key={`l${i}`} className="absolute -translate-x-1/2 -translate-y-[130%] rounded-md bg-teal-600 text-white text-[11px] font-bold px-1.5 py-0.5 shadow pointer-events-none whitespace-nowrap" style={{ left: pct((m.x1 + m.x2) / 2), top: pct((m.y1 + m.y2) / 2) }} data-testid={`mark-label-${m.field}`}>{label(m)}</span>
      ))}
    </>
  );
};

// Miniatura/foto com as medidas marcadas por cima. A <img> define o tamanho (w/h auto) para a sobreposição casar com a imagem.
export const MarkedPhoto = ({ fileId, marks = [], measures = {}, size = 'thumb', compact = false, className = '', imgClassName = 'h-auto', testId }) => (
  <span className={`relative inline-block align-middle leading-none ${className}`} data-testid={testId}>
    <img src={fileUrl(fileId, size)} alt="" className={`block w-auto max-w-full ${imgClassName}`} draggable={false} />
    <MarksOverlay marks={marks} measures={measures} compact={compact} />
  </span>
);
